<section class="main-section-help-user-account" #uninstallChrome>
  <div id="uninstallingChromeBook">
    <div class="main_section_headers" id="mainSectionHeaders">
      <span i18n="@@ipos-help-uninstalling-chromebook.title.uninstalling-chromebook">Uninstalling Chromebook*</span>
    </div>
    <div class="ipos-help-create-account-body" id="iposHelpCreateAccount">
      <div id="uninstallingChromeBookDesc">
        <span i18n="@@ipos-help-uninstalling-chromebook.sub-title.uninstalling-chromebook-desc">Uninstalling Chromebook* is very easy and can be done in a matter of minutes.</span>
      </div>
      <div class="ipos-help-create-account-desc" id="createAccountDesc">
        <div #method1 class="oda-heading-style">
          <div class="expand-view" id="expandView">
            <!-- <span i18n="@@ipos-help-uninstalling-chromebook.title.first-method">METHOD 1</span>
            <div class="table_collapse_link collapsed arrow-icon" data-toggle="collapse"
              [attr.aria-expanded]="isMethod1" aria-controls="collapseOne" id="method1Section">
              <img (click)="showDescription('method1')"
                class="margin-set accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section"
                [ngClass]="isMethod1?'transform-180':''" />
            </div> -->
          </div>
        </div>
        <div id="method1Section" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div"
          id="collapseOne" data-parent="#method1Section" #collapse="ngbCollapse" [(ngbCollapse)]="!isMethod1">
          <ol class="ipos-help-create-account-list mb-1">
            <li i18n="@@ipos-help-uninstalling-chromebook.desc.first-open-homepage">Open the home page in the Chromebook* and press “esc” key to exit from the full screen view.</li>
            <img class="ipos-help-uninstall-chrome-first" alt="uninstall_chrome_first">
            <li i18n="@@ipos-help-uninstalling-chromebook.desc.second-right-click-info-icon">Right-click on the device info icon in the taskbar and select uninstall.</li>
            <img class="ipos-help-uninstall-chrome-second" alt="uninstall_chrome_second">
            <li i18n="@@ipos-help-uninstalling-chromebook.desc.third-select-uninstall">Select “Uninstall” from the Pop-up tab. Chromebook* will be uninstalled from the system.</li>
            <img class="ipos-help-uninstall-chrome-third" alt="uninstall_chrome_third">
          </ol>
        </div>
      </div>
    </div>
  </div>
</section>